import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <main className="flex min-h-[75vh] items-center justify-center bg-[#050b14] px-4 pt-24 text-center text-white">
    <Helmet><title>Page Not Found | PhantomPathVPN</title><meta name="robots" content="noindex" /></Helmet>
    <div><p className="font-mono text-sm font-bold tracking-[0.25em] text-[#00ffc8]">STATUS: 404</p><h1 className="mt-5 text-5xl font-black md:text-7xl">Path not found.</h1><p className="mx-auto mt-5 max-w-lg text-gray-400">This route does not exist or may have moved.</p><Link to="/" className="mt-8 inline-flex rounded-xl bg-[#00ffc8] px-7 py-3 font-black text-[#020617]">Return home</Link></div>
  </main>
);

export default NotFound;
